export default "__VITE_ASSET__CAlbX1uX__"